import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "length",
  standalone: false,
})
export class LengthConversionsPipe implements PipeTransform {
  transform(value: any, conversionUnits: string, digits?: number, showUnits?: boolean): string {
    if (!value && value !== 0) {
      return "Unavailable";
    }

    if (typeof value === "string" && !Number.isNaN(Number(value) - parseFloat(value))) {
      value = Number(value);
    }

    if (typeof value !== "number") {
      return "Unavailable";
    }

    let result;
    switch (conversionUnits) {
      case "in-cm":
        result = value * 2.54;
        break;
      case "cm-in":
        result = value / 2.54;
        break;
      case "ft-m":
        result = value / 3.281;
        break;
      case "m-ft":
        result = value * 3.281;
        break;
      case "yd-m":
        result = value / 1.094;
        break;
      case "m-yd":
        result = value * 1.904;
        break;
      case "mi-km":
        result = value * 1.609;
        break;
      case "km-mi":
        result = value / 1.609;
        break;

      case "in-ft":
        result = value / 12;
        break;
      case "ft-in":
        result = value * 12;
        break;
      case "ft-yd":
        result = value / 3;
        break;
      case "yd-ft":
        result = value * 3;
        break;
      case "ft-mi":
        result = value / 5280;
        break;
      case "mi-ft":
        result = value * 5280;
        break;
      case "yd-mi":
        result = value / 1760;
        break;
      case "mi-yd":
        result = value * 1760;
        break;

      default:
        result = value;
    }

    if (digits || digits === 0) {
      result = result.toFixed(digits);
    }

    if (showUnits && conversionUnits) {
      result += ` ${conversionUnits.split("-")[1]}`;
    }

    return result;
  }
}
